import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-story.module.scss"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import NewsletterPartner from "../newsletter-partner"
import Social from "../social"

const NewsletterStory = ({ section, city, country }) => {
  const { site, allSanityDictionary } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          siteUrl
        }
      }
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
    }
  `)

  const subjectLine = (article) => {
    if (
      article.partner &&
      article.campaign_partner_type === "partner_feature"
    ) {
      return (
        <div className={styles.subject}>
          <Heading level={5}>
            {article.partner.prefix ||
              allSanityDictionary.nodes.find(
                (item) => item.key.current === article.campaign_partner_type
              )?.value}{" "}
            {article.partner.name}
          </Heading>
        </div>
      )
    }
    if (
      article.partner &&
      article.subject &&
      article.campaign_partner_type === "partner_section"
    ) {
      return (
        <div className={styles.subject}>
          <Heading level={5}>{article.subject}</Heading>
          <div className={styles.sectionPartner}>
            <NewsletterPartner
              section={article}
              dictionary={allSanityDictionary.nodes}
              secondary
            />
          </div>
        </div>
      )
    }
    if (article.subject)
      return (
        <div className={styles.subject}>
          <Heading level={5}>{section.article.subject}</Heading>
        </div>
      )
    return null
  }

  const articleUrl = `${site.siteMetadata.siteUrl}${
    section.article.publishing.includes("website")
      ? section.article.partner_url ||
        `/${section.article.web_article_type}/${section.article.slug.current}`
      : ""
  }`

  const featuredImage = (article) => (
    <Image
      {...article.featured_image.image}
      width={670}
      alt={article.featured_image.alt}
    />
  )

  const story = (article) => (
    <div
      className={`${styles.wrapper} ${section.color ? styles[`wrapper__${section.color.replaceAll("-", "")}`] : ""}`}
    >
      {section.regional && section.region_geographic?.image ? (
        <Image
          {...section.region_geographic.image}
          width={670}
          height={150}
          fit="crop"
          className={styles.regionalImage}
        />
      ) : (
        ""
      )}
      <div className={styles.intro}>
        {subjectLine(article)}
        {article.title ? (
          <Heading level={4} html={article.title} className={styles.title} />
        ) : (
          ""
        )}
      </div>
      {article.featured_image && article.featured_image.image ? (
        <>
          {article.partner_url ||
          article.publishing?.includes("website") ||
          article.visible?.includes("website") ? (
            <a
              href={
                article.partner_url ||
                `/${section.article.web_article_type}/${section.article.slug.current}`
              }
              target="_blank"
              rel="noreferrer"
            >
              {featuredImage(article)}
            </a>
          ) : (
            featuredImage(article)
          )}
          <div className={styles.caption}>{article.featured_image.caption}</div>
        </>
      ) : (
        ""
      )}
      <CopyContainer
        bg={section.color}
        className={styles.content}
        content={article._rawContent}
      />
      {section.article.publishing.includes("website") ? (
        <div className={styles.social}>
          <Social shareLink={articleUrl} light story showAllIcons />
        </div>
      ) : (
        ""
      )}
    </div>
  )

  return (
    <>
      {story(section.article)}
      {section.article.is_ss_se
        ? section.article.additional_article_sections?.map((s) =>
            (s.region?._type === "country" &&
              s.region.abbreviation !== country) ||
            (s.region?._type === "city" && city !== s.region.abbreviation)
              ? null
              : story(s)
          )
        : ""}
    </>
  )
}

export default NewsletterStory

NewsletterStory.propTypes = {
  section: PropTypes.object.isRequired,
  city: PropTypes.object.isRequired,
  country: PropTypes.object.isRequired,
}
